export const terminalPayment = ({ original }) => { 
  const getTerminalPaymentType = original?.origin && original.origin !== '' ? original.origin :  original.terminal.type;
  return <span>{getTerminalPaymentType}</span> 
}
